export const ad_user_usuario = ({user, usuario}) => {


    let obj = {
        ...usuario,
        correo: usuario.correo ? usuario.correo : user.email,
        nombre: usuario.nombre ? usuario.nombre : user.displayName,
       // img: usuario.img ? usuario.img : user.photoURL ? user.photoURL : '',
        celular: usuario.celular ? usuario.celular : user.phoneNumber
    }

    return obj

}